import { render, staticRenderFns } from "./social-buttons.vue?vue&type=template&id=89f0b5fe&scoped=true&"
import script from "./social-buttons.vue?vue&type=script&lang=js&"
export * from "./social-buttons.vue?vue&type=script&lang=js&"
import style0 from "./social-buttons.vue?vue&type=style&index=0&id=89f0b5fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f0b5fe",
  null
  
)

export default component.exports